import { useCallback, useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { LOCAL_STORAGE_KEYS } from 'src/constants/local-storage';
import { getLocalStorageValue, setLocalStorageValue } from 'src/utils/local-storage';

const DISMISSAL_CADENCE_DAYS = 14;

function isNumber(value: unknown): value is number {
  return typeof value === 'number';
}

export function useConnectNudgeDismissal(): { readonly isDismissed: boolean; readonly dismiss: () => void } {
  const [dismissedAtMillis, setDismissedAtMillis] = useState<number | null>(null);

  useEffect(() => {
    setDismissedAtMillis(
      getLocalStorageValue<number>({
        dataKey: LOCAL_STORAGE_KEYS.CONNECT_ACCOUNTS_NUDGE_CARD_DISMISSED_AT,
        validator: isNumber,
      }),
    );
  }, []);

  const dismiss = useCallback(() => {
    const nowMillis = DateTime.now().toMillis();
    setLocalStorageValue({
      dataKey: LOCAL_STORAGE_KEYS.CONNECT_ACCOUNTS_NUDGE_CARD_DISMISSED_AT,
      data: nowMillis,
      validator: isNumber,
    });
    setDismissedAtMillis(nowMillis);
  }, []);

  const isDismissed =
    dismissedAtMillis !== null &&
    DateTime.now().diff(DateTime.fromMillis(dismissedAtMillis), 'days').days < DISMISSAL_CADENCE_DAYS;

  return { isDismissed, dismiss };
}
